import React from 'react';
import Card from '@jbhi-fi/lanyard-ui/components/Card';
import { styles } from './NoResultsPlaceholder.css';
import { Icon, IconNameEnum } from '@jbhi-fi/lanyard-ui/components/Icon';
import { IconProps } from '@jbhi-fi/lanyard-ui/components/Icon/CustomIcon';
import { classNames } from '@jbhi-fi/lanyard-ui/global/utils';

export type NoResultsPlaceholderProps = {
  className?: string;
  title: string;
  contents?: string;
  icon?: React.ReactElement | keyof typeof IconNameEnum;
  isMiniProduct?: boolean;
};

export const NoResultsPlaceholder = ({
  className,
  title,
  icon = 'LampIllustrated',
  contents,
  isMiniProduct,
}: NoResultsPlaceholderProps) => {
  return (
    <Card
      shadow={0}
      contentClassName={styles.content}
      className={classNames(styles.container({ isMiniProduct }), className)}
    >
      {typeof icon === 'string' ? <Icon name={icon} fallback={FallbackIcon} placeholder={null} /> : icon}
      <h3>{title}</h3>
      {contents ? <p>{contents}</p> : null}
    </Card>
  );
};

const FallbackIcon = (props: IconProps) => (
  <Icon {...props} name="LampIllustrated" fallback={null} placeholder={null} />
);
